import { ConcreteGranularity } from 'dashboards/types/time';

export const HEATMAP_CHART_GRANULARITIES: [
  ConcreteGranularity,
  ...ConcreteGranularity[],
] = ['DAY', 'HOUR'];
